import { RowInfo } from '../models/row-info';
import { RowId } from './row-id-enum';

export const bRows = (): RowInfo[][] => [b1Rows()];

const b1Rows = (): RowInfo[] => [
  {
    description: 'Tipologia di procedura',
    id: RowId.tipologiaDiProcedura,
    options: [
      {
        view: 'Concordato Liquidatorio (Semplificato o Preventivo)',
        value: 5,
      },
      {
        view: 'Concordato Preventivo con continuità aziendale',
        value: 4,
      },
      {
        view: 'Accordo di Ristrutturazione (art.57 CCII, ex.art. 182Bis)',
        value: 3,
      },
      { view: 'Composizione negoziata crisi di impresa', value: 2 },
      {
        view: 'Piano di risanamento (art.56 CCII, ex. art. 182Bis)',
        value: 1,
      },
    ],
    kriWeight: 100,
  },
];
